import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setFirstField, setSecondField, setThirdField,toggleLeftSampleShow, toggleRightSampleShow } from '../../../actions/checkoutActions'

export class ReceiptPage extends Component {
    constructor(props) {
        super(props);
        this.returnDataFormatted = this.returnDataFormatted.bind(this)
    }

    returnDataFormatted = (data) => {
        var x;
        var dataFormatted = "";

        for (x of data) {
            if (x === '{') {
                dataFormatted += '{\n'
            } else if (x === ',') {
                dataFormatted += ',\n'
            } else if (x === '}') {
                dataFormatted += '\n}'
            } else {
                dataFormatted += x;
            }
        }
        return dataFormatted;
    }

    firstButtonHit = () =>{
        this.props.setFirstField(true)
        this.props.setSecondField(false)
        this.props.setThirdField(false)
    }

    secondButtonHit = () =>{
        this.props.setSecondField(true)
        this.props.setFirstField(false)
        this.props.setThirdField(false)
    }

    thirdButtonHit = () =>{
        this.props.setThirdField(true)
        this.props.setSecondField(false)
        this.props.setFirstField(false)
    }

    render() {
        return (
            <div style={{display: this.props.ifDisplayIframe ? 'none' : 'inline', overflowY:"hidden"}}> 
                <h3>Receipt Request</h3>
                <pre value={JSON.stringify(this.props.receipt, null, 2)} rows="30" cols="90" spellCheck="false">
                    {this.returnDataFormatted(JSON.stringify(this.props.receipt, null, 2))}
                </pre>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { receipt, ifLeftShow, isFirstShow, isSecondShow, ifDisplayIframe, isThirdShow } = state.checkout.main;
    return { receipt, ifLeftShow, isFirstShow, isSecondShow, ifDisplayIframe, isThirdShow };
}

export default connect(mapStateToProps, { toggleLeftSampleShow, toggleRightSampleShow,setFirstField, setSecondField, setThirdField })(ReceiptPage)
